import { ChangeEvent } from 'react';
import { Select } from '@nimbus-ds/components';
import { FormField } from '@nimbus-ds/patterns';
import type { ProductsTemplateCsvType } from '@tiendanube/common';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

type TemplateOption = Readonly<{
  value: ProductsTemplateCsvType;
  label: string;
}>;

interface SelectTemplateProductsCSVProps {
  type: 'import' | 'export';
  value: ProductsTemplateCsvType;
  onChangeTemplate: (template: ProductsTemplateCsvType) => void;
}

function SelectTemplateProductsCSV({
  type,
  value,
  onChangeTemplate,
}: Readonly<SelectTemplateProductsCSVProps>): JSX.Element {
  const t = useTranslationCatalog('products.importExportPage');
  const label = t(`templates.label.${type}`);
  const options: readonly TemplateOption[] = [
    {
      value: 'standard',
      label: t('templates.standard'),
    },
    {
      value: 'metafield_products',
      label: t('templates.metafield_products'),
    },
    {
      value: 'metafield_variants',
      label: t('templates.metafield_variants'),
    },
  ];

  return (
    <FormField.Select
      label={label}
      id="selectTemplateProductsCSV"
      name="selectTemplateProductsCSV"
      value={value}
      onChange={(e: ChangeEvent<HTMLSelectElement>) => {
        const v = e.target.value;
        if (
          v === 'standard' ||
          v === 'metafield_products' ||
          v === 'metafield_variants'
        ) {
          onChangeTemplate(v);
        }
      }}
    >
      {options.map(({ value, label }) => (
        <Select.Option key={value} value={value} label={label} />
      ))}
    </FormField.Select>
  );
}

export default SelectTemplateProductsCSV;
